export default function ShareLinkedin() {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.91208 26.822H8.34542V10.4187H3.91208V26.822ZM6.12875 3.17755C4.65097 3.17755 3.46875 4.35977 3.46875 5.83755C3.46875 7.31533 4.65097 8.49755 6.12875 8.49755C7.60653 8.49755 8.78875 7.31533 8.78875 5.83755C8.78875 4.35977 7.60653 3.17755 6.12875 3.17755ZM15.8821 12.9309V10.4187H11.4488V26.822H15.8821V18.3987C15.8821 13.6698 21.941 13.3742 21.941 18.3987V26.822H26.3743V16.7731C26.3743 8.79311 17.951 9.08866 15.8821 12.9309Z"
        fill="#222424"
      />
    </svg>
  );
}
